import {
  Component,
  OnInit,
  OnDestroy,
  ViewChildren,
  AfterViewInit,
  Output,
  EventEmitter,
  ViewChild,
  HostListener,
  ElementRef
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { ApiService } from 'src/app/core/services/api.service';
import { Subscription } from 'rxjs';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { Common } from 'src/app/core/constants/common';
import { LoginBase } from '../../login/login-base';
import { TranslateService } from '@ngx-translate/core';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'app-reset-password-exists',
  templateUrl: './reset-password-exists.component.html',
  styleUrls: ['./reset-password-exists.component.scss']
})

export class ResetPasswordExistsComponent extends LoginBase implements OnInit {
  @Output() changeLanguage = new EventEmitter<boolean>();
  id = 1;

  constructor(
    private router: Router,
    private translate: TranslateService,
  ) {
    super();
  }

  ngOnInit() {
  }

  cancel() {
    this.router.navigate(['/enterprise-login']);
  }

  resendPassword() {
    this.router.navigate([`/request-password-reset/${this.id}`]);
  }
   /**
   * Method name: onChangeLanguage
   */
  onChangeLanguage(languageSelected: string) {
    this.setLanguagelocalStored(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
  }
}
